<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">
          {{ $t(pageTitle) }}
        </h1>
        <div class="table-input inner">
          <div class="content">
            <table class="table table-bordered">
              <tbody class="tbody">
                <tr>
                  <th class="table-active text-left">{{ $t('製品種別') }}</th>
                  <td class="text-left" colspan="3">
                    <div class="form-check form-check-inline">
                      <input v-model="form.type"
                      class="form-check-input"
                      type="radio" id="type1" value="ownbrand">
                      <label class="form-check-label" for="type1">
                      {{ $t("内製品") }}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input v-model="form.type"
                      class="form-check-input"
                      type="radio" id="type2" value="purchase">
                      <label class="form-check-label" for="type2">
                      {{ $t("仕入品") }}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input v-model="form.type"
                      class="form-check-input"
                      type="radio" id="type3" value="material">
                      <label class="form-check-label" for="type3">
                      {{ $t("材料") }}
                      </label>
                    </div>
                  </td>
                  <th class="table-active text-left">{{ $t('登録日') }}</th>
                  <td class="text-left">
                    <div class="input-group w-100">
                      <date-picker v-model="form.registerDate" :config="datepicker.options" class="calendar w-100 hf-30"></date-picker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <font-awesome-icon :icon="['far', 'calendar-alt']" />
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">
                    <template v-if="form.type === 'material'">
                      {{ $t('材料コード') }}
                    </template>
                    <template v-else>
                      {{ $t('品番') }}
                    </template>
                  <span class="text-danger">&nbsp;{{ $t("※必須") }}</span></th>
                  <td class="text-left">
                    <input v-model="form.code" type="text" :class="{'form-control':true, input: true,'border-danger': error,}">
                  </td>
                  <th class="table-active text-left">{{ $t('改訂') }}</th>
                  <td class="text-left" colspan="1">
                    <input v-model="form.version" type="text" class="form-control input">
                  </td>
                  <th class="table-active text-left">
                    <template v-if="form.type === 'material'">
                      {{ $t('材料名/材質') }}
                    </template>
                    <template v-else>
                      {{ $t('品名') }}
                    </template>
                  </th>
                  <td class="text-left">
                    <input v-model="form.name" type="text" class="form-control input">
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">
                    {{ $t('図番') }}
                  </th>
                  <td class="text-left">
                    <input v-model="form.figureNo" type="text" class="form-control input">
                  </td>
                  <th class="table-active text-left">{{ $t('単位') }}</th>
                  <td class="text-left">
                    <input v-model="form.outputLevel" type="text" class="form-control input">
                  </td>
                  <th class="table-active text-left">{{ $t('RoHS指令対応') }}</th>
                  <td class="text-left">
                    <input v-model="form.isRoHS" type="checkbox" class="checkbox">
                  </td>
                </tr>
                <tr>
                  <template v-if="form.type === 'material' || form.type === 'purchase' ">
                      <th class="table-active text-left">{{ $t('メーカー') }}</th>
                      <td class="text-left">
                        <input v-model="form.supplier" type="text" class="form-control" />
                      </td>
                  </template>
                  <template v-if="form.type === 'material'">
                    <th class="table-active text-left">{{ $t('基準手配リードタイム') }}</th>
                    <td class="text-left">
                      <div class="input-group w-100">
                        <input v-model.number="form.materialLeadTime" type="number" min="0" class="form-control input">
                        <div class="input-group-append">
                          <span class="input-group-text">
                            {{ $t('日') }}
                          </span>
                        </div>
                      </div>
                    </td>
                  </template>
                </tr>
                <tr>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目1') }}
                  </th>
                  <td class="text-left">
                    <input v-model="form.freeText1" type="text" class="form-control input">
                  </td>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目2') }}
                  </th>
                  <td class="text-left">
                    <input v-model="form.freeText2" type="text" class="form-control input">
                  </td>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目3') }}
                  </th>
                  <td class="text-left">
                    <input v-model="form.freeText3" type="text" class="form-control input">
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目4') }}
                  </th>
                  <td class="text-left">
                    <input v-model="form.freeText4" type="text" class="form-control input">
                  </td>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目5') }}
                  </th>
                  <td class="text-left">
                    <input v-model="form.freeText5" type="text" class="form-control input">
                  </td>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目6') }}
                  </th>
                  <td class="text-left">
                    <input v-model="form.freeText6" type="text" class="form-control input">
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目7') }}
                  </th>
                  <td class="text-left" colspan="5">
                    <input v-model="form.freeText7" type="text" class="form-control input">
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目8') }}
                  </th>
                  <td class="text-left" colspan="5">
                    <input v-model="form.freeText8" type="text" class="form-control input">
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">
                    {{ $t('自由記述項目9') }}
                  </th>
                  <td class="text-left" colspan="5">
                    <input v-model="form.freeText9" type="text" class="form-control input">
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left">{{ $t('備考') }}</th>
                  <td class="text-left" colspan="5">
                    <input v-model="form.note" type="text" class="form-control input">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p class="inner text-danger text-left" v-if="error">{{ error }}</p>
        <div class="inner d-flex justify-content-start mt-4 mb-4">
          <button type="button" class="btn btn-success mr-3 d-flex align-items-center justify-content-center wf-60" :disabled="registering" @click="register()">
              <div class="d-flex justify-content-center align-items-center mr-3" v-if="registering">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </div>
              {{ $t("登録") }}
          </button>
          <button type="button" class="btn btn-light"  :disabled="registering" @click="returnPage()">{{ $t("キャンセル") }}</button>
        </div>
        <p v-if="status === 'new'" class="inner text-danger">{{ $t('図面や標準工程は製品登録後に登録できます') }}</p>
      </div>
  </common-template>
</template>

<script>
import moment from 'moment/moment'
import { mapGetters } from 'vuex'

const form = {
  type: 'ownbrand',
  registerDate: '',
  code: '',
  name: '',
  figureNo: '',
  version: '',
  isRoHS: false,
  supplier: '',
  outputLevel: '',
  materialLeadTime: null,
  salesPrice: null,
  purchasePrice: null,
  shapeType: '',
  shapeValues: [],
  shapeWeight: null,
  note: '',
  shapeNote: '',
}

const formSetting = {
  type: {type: 'enum'},
  registerDate: {type: 'date'},
  code: {type: 'string'},
  name: {type: 'string'},
  figureNo: {type: 'string'},
  version: {type: 'string'},
  isRoHS: {type: 'boolean'},
  supplier: {type: 'string'},
  outputLevel: {type: 'string'},
  materialLeadTime: {type: 'number'},
  salesPrice: {type: 'number'},
  purchasePrice: {type: 'number'},
  shapeType: {type: 'enum'},
  shapeValues: {type: 'array'},
  shapeWeight: {type: 'number'},
  note: {type: 'string'},
  shapeNote: {type: 'string'},
  freeText1: {type: 'string'},
  freeText2: {type: 'string'},
  freeText3: {type: 'string'},
  freeText4: {type: 'string'},
  freeText5: {type: 'string'},
  freeText6: {type: 'string'},
  freeText7: {type: 'string'},
  freeText8: {type: 'string'},
  freeText9: {type: 'string'},
}

export default {
  data() {
    return {
      form: {},
      error: '',
      registering: false,
      status: 'new',
      collapseActive: true,
      pageTitle: '製品登録',
    }
  },
  async created() {
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(err)
      this.$toasted.show('Userの取得でエラー')
    }
    try {
      // パラメータがあれば、Formにデータを入れる
      const url = location.search
      const searchParams = new URLSearchParams(url)
      if (searchParams.get('id')) {
        // idがあればapiから製品の情報を取得
        let params = {
          id: searchParams.get('id'),
        }
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/products`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
          params: params,
        })
        this.form = res.data[0]
        this.status = 'fix'
      } else {

        this.form = this.mixin_deepcopy(form)
      }
    } catch (err) {
      this.$toasted.show(err)
    }
    const url = location.search
    const searchParams = new URLSearchParams(url)
    if (searchParams.get('code')) {
      this.form.code = String(searchParams.get('code'))
    }
  },
  mounted() {
    $('#drawing').on('show.bs.collapse', function() {
      const up = document.getElementById('drawing-up')
      const down = document.getElementById('drawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#drawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('drawing-up')
      const down = document.getElementById('drawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
    $('#drawing').collapse('show')
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  methods: {
    // 製品寸法が変更されたらそれにともなって製品寸法の値の数を変更
    shapeTypeChange() {
      if (this.form.shapeType === 'round') {
        this.form.shapeValues = [0, 0]
      } else if (this.form.shapeType == 'corner' || this.form.shapeType == 'plate') {
        this.form.shapeValues = [0, 0, 0]
      } else {
        this.form.shapeType = []
      }
    },
    // 製品の一覧か詳細に戻る処理
    returnPage() {
      window.history.back()
    },
    // 登録処理
    async register() {
      if (!this.form.code) return this.error = this.$t('品番') + this.$t('必須メッセージ')
      this.error = ''
      this.registering = true
      let params = {}
      for (let key of Object.keys(this.form)) {
        if (formSetting[key] && formSetting[key].type === 'string') {
          params[key] = this.form[key] || ''
        } else if (key === 'registerDate') {
          if (!this.form[key]) params[key] = moment().format('YYYY-MM-DD')
        } else if (formSetting[key] && formSetting[key].type === 'number') {
          if (this.form[key] !== null && this.form[key] !== void 0) {
            params[key] = Number(this.form[key])
          }
        } else if (this.form[key]) {
          params[key] = this.form[key]
        }
      }
      try {
        const res = await this.$axios({
          method: 'post',
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/product`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))

        // とりあえず一覧に移動させる
        window.location.href = process.env.NODE_ENV !== 'development' ? `/base/product/detail.html?id=${res.data.id}` : `/product/detail.html?id=${res.data.id}`
      } catch (error) {
        if (error.response.data.detail) {
          if (error.response.data.detail.productCode) {
            this.$toasted.show(
              this.$t(
                error.response.data.detail.productCode,
                {productCode: params.code, productVersion: params.version}
              )
            )
          }
        } else {
          this.$toasted.show(this.$t('データ登録エラーメッセージ'))
        }
      }
      this.registering = false
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .accordion {
    cursor: pointer;
  }
  .table-active{
    width: 170px;
  }
  .checkbox{
      transform: scale(1.3);
  }
</style>
